<!-- 新建/编辑 -->
<template>
  <div class="addMsg" v-loading="loading">
    <el-form
      ref="oneForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      label-position="left"
      @keyup.native.enter="onAction('发布')"
    >
      <el-form-item label="站内信标题:" prop="title">
        <el-input
          v-model.trim="ruleForm.title"
          placeholder="请输入站内信标题"
          maxlength="30"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="站内信内容:" prop="content">
        <el-input
          v-model.trim="ruleForm.content"
          placeholder="请输入站内信内容"
          maxlength="1000"
          show-word-limit
          clearable
          type="textarea"
          :rows="4"
        ></el-input>
      </el-form-item>
      <el-form-item label="发布范围:" prop="noData">
        <SelectViewRange
          v-if="showSelectViewRange"
          ref="viewRangeAll"
          :user-id-list="ruleForm.user_ids"
          :department-id-list="ruleForm.dept_ids"
          :disable-select-all="true"
          :no-label="true"
        ></SelectViewRange>
      </el-form-item>
    </el-form>
    <div class="action_line">
      <el-button @click="onAction('取消')">取消</el-button>
      <el-button type="primary" @click="onAction('保存')">保存</el-button>
      <el-button type="primary" @click="submitDialogVisible = true">发布</el-button>
    </div>
    <el-dialog title="发布提示" :visible.sync="submitDialogVisible" width="30%" center>
      <div style="text-align: center">确定发布此条站内信吗</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            () => {
              submitDialogVisible = false;
              onAction('发布');
            }
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  CreateInMail,
  GetInMailDetail,
  UpdateInMail,
  PubInMailById,
} from '@/api/webSiteMsgManagement';
import SelectViewRange from '@/components/selectViewRange';
export default {
  name: 'AddMsg',
  components: { SelectViewRange },
  props: {},
  data() {
    return {
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
      },
      ruleForm: {
        title: '',
        content: '',
        user_ids: [],
        dept_ids: [],
      },
      ruleFormInit: {
        title: '',
        content: '',
      },
      loading: false, // 表单加载
      submitDialogVisible: false,
      showSelectViewRange: false,
    };
  },
  computed: {
    // id
    locationId() {
      return Number(this.$route.query.id);
    },
  },
  watch: {},
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.setBreadcrumb();
      // 编辑
      if (this.locationId) {
        this.getData();
      } else {
        this.showSelectViewRange = true;
      }
    },
    // 设置面包屑
    setBreadcrumb() {
      let breadcrumb = [];
      breadcrumb = [
        { menu_name: '功能', menu_path: '' },
        { menu_name: '站内信管理', menu_path: 'webSiteMsgManagement' },
        { menu_name: this.locationId ? '编辑站内信' : '新建站内信' },
      ];
      this.$store.commit('user/setBreadcrumb', breadcrumb);
    },
    // 获取题目详情
    async getData() {
      this.loading = true;
      try {
        const res = await GetInMailDetail({
          id: this.locationId,
        });
        this.ruleForm = res;
        this.showSelectViewRange = true;
      } catch (error) {
        this.$message.error(error.message);
      }
      this.loading = false;
    },
    // 表单校验
    checkForm() {
      return new Promise((resolve, reject) => {
        let boolean = true;
        this.$refs.oneForm.validate((valid) => {
          boolean = valid;
        });
        if (!this.$refs.viewRangeAll.hasSelection) {
          this.$message.error('请选择范围');
          boolean = false;
        }
        boolean ? resolve() : reject();
      });
    },
    // 重置表单
    resetForm() {
      const ruleForm = {
        ...JSON.parse(JSON.stringify(this.ruleFormInit)),
      };
      this.ruleForm = ruleForm;
    },
    // 提交/取消操作
    onAction(e) {
      if (e === '取消') {
        this.$router.go(-1);
        return;
      }
      const { userIds, departIds } = this.$refs.viewRangeAll.submitForm();
      this.ruleForm.user_ids = userIds;
      this.ruleForm.dept_ids = departIds;
      switch (e) {
        case '保存':
          this.checkForm().then(async () => {
            this.loading = true;
            const flag = await this.saveData(this.ruleForm);
            this.loading = false;
            flag ? this.$router.go(-1) : '';
          });
          break;
        case '发布':
          this.checkForm().then(async () => {
            this.loading = true;
            let flag = await this.saveData(this.ruleForm);
            console.log(this.ruleForm);
            if (!flag) {
              this.loading = false;
              return;
            }
            flag = await this.publicData(this.ruleForm.id);
            this.loading = false;
            flag ? this.$router.go(-1) : '';
          });
          break;
        default:
          break;
      }
    },
    // 保存数据
    async saveData(ruleForm) {
      try {
        if (ruleForm.id) {
          await UpdateInMail({
            ...ruleForm,
          });
        } else {
          const res = await CreateInMail({
            ...ruleForm,
          });
          this.ruleForm.id = res.id;
        }
        this.$message.success('保存成功');
        return true;
      } catch (error) {
        this.$message.error(error.message);
      }
      return false;
    },
    // 发布数据
    async publicData(id) {
      try {
        await PubInMailById({ id });
        this.$message.success('发布成功');
        return true;
      } catch (error) {
        this.$message.error(error.message);
      }
    },
  },
};
</script>

<style>
.avatar-uploader {
  position: relative;
  line-height: 0px;
}

.avatar-uploader .el-upload {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.del_img {
  position: absolute;
  bottom: 0;
  left: 0;
  display: inline-block;
  width: 100%;
  line-height: 30px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.65);
  text-align: center;
}
.del_img:hover {
  background-color: #000;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>

<style lang="scss" scoped>
.addMsg {
  width: 60%;
  .input_line {
    display: flex;
    .del_text {
      margin-left: 10px;
      width: 35px;
    }
  }
  .upload_line {
    display: flex;
    align-items: flex-end;
    padding: 10px 0 15px 0;
    .img_text {
      display: inline-block;
      font-size: 12px;
      color: #939599;
      line-height: 20px;
      width: 200px;
      margin-left: 10px;
    }
  }
  .action_line {
    padding-top: 40px;
  }
  .sortable_item {
    // cursor: move;
  }
  .sortable_move {
    box-sizing: border-box;
    border: 1px dashed #2f96ff;
    border-radius: 6px;
    padding: 1px 1px 0 1px;
    margin-bottom: 1px;
  }
}
</style>
